import { AaasModalNames } from '@va/aaas/shared/constants';
import { AaasAppSelectors, selectIntpWebsite, selectStpRates } from '@va/aaas/shared/selectors';
import { AaasBillingMode, AaasSubscriptionType, IntpWebsite, StpCounterResponse } from '@va/aaas/shared/types';
import { featureTourFlagKeys, is3ASUnlimitedFreeTrialPlan } from '@va/constants';
import { openModal } from '@va/dashboard/actions/ui';
import { put, select } from 'redux-saga/effects';

export function* initializeModals() {
  const website: IntpWebsite = yield select(selectIntpWebsite);
  const stpRates: StpCounterResponse = yield select(selectStpRates);
  const isFirstLogin: boolean = yield select(AaasAppSelectors.isFirstLogin);

  let freeTrialEndedModalShown = false;
  let subscriptionEndedModalShown = false;

  const isOnUpgradePage = window.location.pathname.includes('/upgrade');

  if (
    website.subscriptionType === AaasSubscriptionType.Intpc &&
    website.billingMode === AaasBillingMode.PlatformManaged &&
    website.hadTrial &&
    stpRates.pool?.limit === 0 &&
    website.previousPackage &&
    is3ASUnlimitedFreeTrialPlan(website.previousPackage.name) &&
    !isOnUpgradePage
  ) {
    yield put(openModal(AaasModalNames.freeTrialEnded_14days_accountSubscription_noFreePlan));
    freeTrialEndedModalShown = true;
  } else if (
    website.subscriptionType === AaasSubscriptionType.Intpc &&
    website.billingMode === AaasBillingMode.PlatformManaged &&
    website.hadTrial &&
    stpRates.pool?.limit === 0 &&
    (!website.previousPackage || !is3ASUnlimitedFreeTrialPlan(website.previousPackage?.name)) &&
    !isOnUpgradePage
  ) {
    yield put(openModal(AaasModalNames.subscriptionEnded_accountSubscription_noFreePlan));
    subscriptionEndedModalShown = true;
  }

  if (isFirstLogin && !freeTrialEndedModalShown && !subscriptionEndedModalShown) {
    yield put(openModal(featureTourFlagKeys.dashboard));
  }
}
